import { Redirect, useLocalSearchParams } from 'expo-router';

function toCanonicalGeneratePath(params: Record<string, string | string[] | undefined>) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item != null && item !== '') query.append(key, String(item));
      });
      return;
    }
    if (value != null && value !== '') {
      query.set(key, String(value));
    }
  });
  const qs = query.toString();
  return `/learn/path/generate${qs ? `?${qs}` : ''}`;
}

export default function KursiPlayGenerateLegacyRedirect() {
  const params = useLocalSearchParams();
  return <Redirect href={toCanonicalGeneratePath(params)} />;
}
